import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { PRIVATE_ROUTES } from '../../../routes'
import { loginState } from '../../login/login.slice'
import ProjectPrototypeDetailsView from './ProjectPrototypeDetailsView'
import ProjectPrototypeListView from './ProjectPrototypeListView'

const ProjectPrototype = ({
    projectId,
    prototypeId = null,
    readOnly = false,
    canDelete = false,
}) => {
    const navigate = useNavigate()
    const { userProfile } = useSelector(loginState)

    const isClientUser = useMemo(
        () =>
            Boolean(
                userProfile?.isSupportUser &&
                    !userProfile?.isExistingUser &&
                    !userProfile?.isSuperAdmin
            ),
        [
            userProfile?.isSupportUser,
            userProfile?.isExistingUser,
            userProfile?.isSuperAdmin,
        ]
    )

    const editorUser = useMemo(() => {
        if (!userProfile?._id) return null
        return {
            id: String(userProfile._id),
            name: userProfile.name || userProfile.email || 'User',
            avatarColor: userProfile.avatarColor || '#4f7df3',
        }
    }, [
        userProfile?._id,
        userProfile?.name,
        userProfile?.email,
        userProfile?.avatarColor,
    ])

    const openPrototypePage = useCallback(
        (id) => {
            if (!projectId || !id) return
            navigate(PRIVATE_ROUTES.projects.projectPrototype(projectId, id))
        },
        [navigate, projectId]
    )

    const backToPrototypeList = useCallback(() => {
        if (!projectId) return
        navigate(PRIVATE_ROUTES.projects.projectIdView(projectId, 'prototype'))
    }, [navigate, projectId])

    if (prototypeId) {
        return (
            <ProjectPrototypeDetailsView
                prototypeId={prototypeId}
                editorUser={editorUser}
                onBack={backToPrototypeList}
                readOnly={readOnly}
                canDelete={canDelete}
                isSuperAdmin={Boolean(userProfile?.isSuperAdmin)}
                isClientUser={isClientUser}
            />
        )
    }

    return (
        <ProjectPrototypeListView
            projectId={projectId}
            readOnly={readOnly}
            canDelete={canDelete}
            onOpen={openPrototypePage}
        />
    )
}

export default ProjectPrototype
